import axios from 'axios';
// import awsAuth from '@/utils/aws-auth';
import router from '@/router';
import store from '@/store';

const HTTP = axios.create({
  baseURL: process.env.VUE_APP_HTTP_ENDPOINT,
  headers: {
    'Content-Type': 'application/json',
  },
});

HTTP.interceptors.response.use(response => response, (error) => {
  if (error.response.status === 401) {
    store.dispatch('logout');
    router.push({ name: 'login' });
  }
  return Promise.reject(error);
});

const SEARCH = axios.create({
  baseURL: process.env.VUE_APP_SEARCH_ENDPOINT,
  headers: {
    'Content-Type': 'application/json',
  },
});

// SEARCH.interceptors.request.use((config) => {
//  const copy = config;
//  if (process.env.VUE_APP_SEARCH_ENDPOINT.match(/amazonaws.com/i)) {
//    copy.headers['Content-Type'] = 'application/json';
//    copy.headers.Host = copy.baseURL.replace(/http(s)?:\/{2}/, '');
//    copy.headers['X-Amz-Date'] = new Date().toISOString().replace(/[:-]|\.\d{3}/g, '');
//    copy.headers.Authorization = awsAuth.authorize(copy);
//    const signedHeaders = copy.headers;
//    delete signedHeaders.Host;
//    copy.headers = signedHeaders;
//  }
//  return copy;
// });

export {
  HTTP,
  SEARCH,
};
